import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { getRSVPInviteBySlug } from '../../services/rsvpInviteService'
import './RSVPInvitePage.css'

function RSVPInvitePage() {
  const { slug } = useParams()
  const navigate = useNavigate()
  const [invite, setInvite] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const loadInvite = async () => {
      try {
        setLoading(true)
        
        if (process.env.NODE_ENV === 'development') {
          console.log('RSVPInvitePage: Loading invite with slug:', slug)
        }
        
        const inviteData = await getRSVPInviteBySlug(slug)
        
        if (process.env.NODE_ENV === 'development') {
          console.log('RSVPInvitePage: Invite data received:', inviteData)
        }
        
        if (!inviteData) {
          if (process.env.NODE_ENV === 'development') {
            console.warn('RSVPInvitePage: No invite data returned for slug:', slug)
            console.warn('Possible causes:')
            console.warn('1. Invitation does not exist with slug:', slug)
            console.warn('2. web_enabled is FALSE for this invitation')
            console.warn('3. RLS policies blocking public access')
          }
          setLoading(false)
          return
        }
        
        setInvite(inviteData)
      } catch (error) {
        console.error('RSVPInvitePage: Error loading invite:', error)
        console.error('Error details:', {
          message: error.message,
          code: error.code,
          slug: slug,
          stack: error.stack
        })
      } finally {
        setLoading(false)
      }
    }

    if (slug) {
      loadInvite()
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.warn('RSVPInvitePage: No slug provided')
      }
      setLoading(false)
    }
  }, [slug])

  const handleRSVPClick = () => {
    navigate(`/rsvp/${slug}/search`)
  }

  const formatDate = (dateString) => {
    if (!dateString) return ''
    try {
      const date = new Date(dateString)
      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
      return `${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`
    } catch {
      return dateString
    }
  }

  if (loading) {
    return (
      <div className="rsvp-invite-page">
        <div className="rsvp-invite-container">
          <div className="rsvp-loading">Loading...</div>
        </div>
      </div>
    )
  }

  if (!invite && !loading) {
    return (
      <div className="rsvp-invite-page">
        <div className="rsvp-invite-container">
          <div className="rsvp-error">
            <h2>Invitation not found</h2>
            <p>The invitation link you're trying to access doesn't exist or may have been removed.</p>
            <p>Please check the link and try again, or contact the couple for a new invitation.</p>
            <details style={{ marginTop: '1rem', fontSize: '0.875rem', color: '#666' }}>
              <summary style={{ cursor: 'pointer', marginBottom: '0.5rem' }}>Debug Info</summary>
              <p>Slug: {slug}</p>
              <p>URL: {window.location.href}</p>
              <p>Check the browser console for more details.</p>
            </details>
          </div>
        </div>
      </div>
    )
  }

  const coupleNames = invite.partner2_name 
    ? `${invite.partner1_name} & ${invite.partner2_name}`
    : invite.partner1_name

  return (
    <div className="rsvp-invite-page">
      <div className="rsvp-invite-container">
        {/* Image Section */}
        {invite.image_url && (
          <div className="rsvp-invite-image">
            <img src={invite.image_url} alt="Wedding" />
          </div>
        )}

        {/* Content Section */}
        <div className="rsvp-invite-content">
          {invite.title && (
            <div className="rsvp-invite-title-small">{invite.title}</div>
          )}
          <div className="rsvp-invite-names">{coupleNames}</div>
          {invite.wedding_date && (
            <div className="rsvp-invite-date">{formatDate(invite.wedding_date)}</div>
          )}
          {invite.wedding_venue && (
            <div className="rsvp-invite-venue">{invite.wedding_venue}</div>
          )}
          {invite.message && (
            <div className="rsvp-invite-message">{invite.message}</div>
          )}
        </div>

        {/* RSVP Button - invitados solo ven el botón; Copy Link y texto van en Craft Your Invite */}
        <div className="rsvp-invite-actions">
          <button 
            className="rsvp-invite-btn"
            onClick={handleRSVPClick}
          >
            RSVP
          </button>
        </div>
      </div>
    </div>
  )
}

export default RSVPInvitePage
